import React from "react";

const InternetExplain = () => {
  return (
    <section id="why-site" className="py-24 bg-gray-100">
      <div className="container mx-auto px-4">
        <h2
          className="text-4xl md:text-5xl font-extrabold mb-12 text-blue-900 text-center"
          data-aos="fade-up"
        >
          Pourquoi posséder un site internet ?
        </h2>
        <div className="flex flex-wrap md:flex-nowrap justify-center">
          {/* Premier Card */}
          <div
            className="w-full md:w-1/3 p-4"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <div className="bg-white p-8 rounded-xl shadow-lg flex flex-col items-center text-center">
              <div className="mb-6 text-blue-600">
                <i className="fas fa-laptop-code fa-3x"></i>
              </div>
              <h3 className="text-2xl font-semibold text-gray-900 mb-4">
                Votre vitrine en ligne
              </h3>
              <p className="text-lg text-gray-700">
                Un site internet est souvent la première interaction que les
                clients ont avec votre entreprise. Il doit refléter votre
                professionnalisme, votre expertise et vos valeurs de manière
                percutante et mémorable.
              </p>
            </div>
          </div>
          {/* Deuxième Card */}
          <div
            className="w-full md:w-1/3 p-4"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            <div className="bg-white p-8 rounded-xl shadow-lg flex flex-col items-center text-center">
              <div className="mb-6 text-blue-600">
                <i className="fas fa-globe-americas fa-3x"></i>
              </div>
              <h3 className="text-2xl font-semibold text-gray-900 mb-4">
                Disponibilité mondiale
              </h3>
              <p className="text-lg text-gray-700">
                Avec un site web, votre entreprise est accessible à tout moment
                et de partout dans le monde. Cela vous permet de toucher un
                public international sans les contraintes géographiques.
              </p>
            </div>
          </div>
          {/* Troisième Card */}
          <div
            className="w-full md:w-1/3 p-4"
            data-aos="fade-up"
            data-aos-delay="600"
          >
            <div className="bg-white p-8 rounded-xl shadow-lg flex flex-col items-center text-center">
              <div className="mb-6 text-blue-600">
                <i className="fas fa-chart-line fa-3x"></i>
              </div>
              <h3 className="text-2xl font-semibold text-gray-900 mb-4">
                Maximisation des conversions
              </h3>
              <p className="text-lg text-gray-700">
                Un site internet bien conçu optimise l'expérience utilisateur et
                guide les visiteurs vers l'action désirée, transformant ainsi
                les visiteurs en clients potentiels.
              </p>
            </div>
          </div>
        </div>
        <div className="text-center mt-16">
          <h4 className="text-2xl font-semibold text-blue-900 mb-4">
            Vous avez des questions ?
          </h4>
          <p className="text-lg text-gray-700 mb-6">
            Peut-être que vous trouverez la réponse dans notre FAQ.
          </p>
          <a
            href="/foire-aux-questions"
            className="inline-block px-8 py-4 bg-blue-600 text-white text-lg font-semibold rounded-md hover:bg-blue-500 transition-colors duration-300"
          >
            Voir la FAQ
          </a>
        </div>
      </div>
    </section>
  );
};

export default InternetExplain;
